import { observer } from 'mobx-react'
import React, { FC } from 'react'
import FirstIntakeStep from './FirstIntakeStep'
import SecondIntakeStep from './SecondIntakeStep'
import { IVendorsLeadIntakeModel } from './model/VendorsLeadIntakeModel'
import ThirdIntakeStep from './ThirdIntakeStep'
import { injectIntl } from 'react-intl'

interface IIntakeSteps {
    model: IVendorsLeadIntakeModel
    intl: any
}

const IntakeSteps: FC<IIntakeSteps> = observer(({ model, intl }) => {
  model.setIntl(intl)
  return (
        <div>
            {model.currentStep === 0 && <FirstIntakeStep model={model}/>}
            {model.currentStep === 1 && <SecondIntakeStep model={model}/>}
            {model.currentStep === 2 && <ThirdIntakeStep model={model}/>}
        </div>
  )
})

export default injectIntl(IntakeSteps)
